import React, { useState, useRef, useEffect } from 'react';
import { Box, Typography, TextField } from '@mui/material';
import { SubmittedBadge, labelStyle } from './ClosestNumber.game';
import { MinigameStateSnapshot } from '../../../shared/events';

interface Props {
  minigame: MinigameStateSnapshot;
  submitted: boolean;
  onSubmit: (answer: string) => void;
}

const TypeTheWord: React.FC<Props> = ({ minigame, submitted, onSubmit }) => {
  const [value, setValue] = useState('');
  const inputRef = useRef<HTMLInputElement>(null);
  const word = minigame.word ?? '';

  useEffect(() => { inputRef.current?.focus(); }, []);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const v = e.target.value;
    setValue(v);
    if (v.toLowerCase().trim() === word.toLowerCase()) {
      onSubmit(v.trim());
    }
  };

  if (submitted) return <SubmittedBadge label="Typed it!" />;

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 3, width: '100%', maxWidth: 380 }}>
      <Typography sx={labelStyle}>Type this word as fast as you can:</Typography>
      <Box
        sx={{
          background: 'rgba(255,255,255,0.15)', border: '3px solid rgba(255,255,255,0.4)',
          borderRadius: '16px', px: 4, py: 2,
        }}
      >
        <Typography
          sx={{
            fontFamily: 'monospace', fontSize: '2.2rem', fontWeight: 'bold',
            color: 'white', letterSpacing: '0.15em',
            textShadow: '2px 2px 0 rgba(0,0,0,0.4)',
          }}
        >
          {word}
        </Typography>
      </Box>
      <TextField
        inputRef={inputRef}
        value={value}
        onChange={handleChange}
        onKeyDown={e => { if (e.key === 'Enter' && value.trim()) onSubmit(value.trim()); }}
        placeholder="Type here…"
        autoComplete="off"
        autoCorrect="off"
        autoCapitalize="off"
        spellCheck={false}
        sx={{ background: 'rgba(255,255,255,0.9)', borderRadius: '12px', width: '100%' }}
      />

    </Box>
  );
};

export default TypeTheWord;
